import {MC_Constants} from "../MC_Constants";

export class MC_User {
    
    public static FIELD_UID: string = "uid";
    public static FIELD_NAME: string = "name";
    public static FIELD_EMAIL: string = "email";
    public static FIELD_PHONE: string = "phone";
    public static FIELD_ENABLED: string = "enabled";
    public static FIELD_ADMIN: string = "admin";
    public static FIELD_ORG_IDS: string = "organization_ids";
    public static FIELD_CREATED: string = "created";
    public static FIELD_MODIFIED: string = "modified";
    public static FIELD_LAST_ACTIVITY: string = "last_activity";
    public static FIELD_ADMIN_NOTES: string = "admin_notes";

    constructor(
        public uid: string,
        public enabled: boolean,
        public admin: boolean,
        public name: string,
        public email: string,
        public phone: string,
        public organizationIDs: string[],
        public created: Date | null,
        public modified: Date | null,
        public lastActivity: Date | null,
        public adminNotes: string
    ) {}

    public toJSON(): any {
        let dataObj: any = {};
        dataObj[MC_User.FIELD_UID] = this.uid;
        dataObj[MC_User.FIELD_NAME] = this.name;
        dataObj[MC_User.FIELD_EMAIL] = this.email;
        dataObj[MC_User.FIELD_PHONE] = this.phone;
        dataObj[MC_User.FIELD_ENABLED] = this.enabled;
        dataObj[MC_User.FIELD_ADMIN] = this.admin;
        dataObj[MC_User.FIELD_ORG_IDS] = this.organizationIDs;
        dataObj[MC_User.FIELD_ADMIN_NOTES] = this.adminNotes;
        return dataObj;
    }

    public getLastActivityStr(): string {
        return MC_Constants.getReadableDateStr(this.lastActivity);
    }

    public static fromData(data: any): MC_User {
        let created = MC_Constants.parseDate(data[this.FIELD_CREATED]);
        let modified = MC_Constants.parseDate(data[this.FIELD_MODIFIED]);
        let lastActivity = MC_Constants.parseDate(data[this.FIELD_LAST_ACTIVITY]);
        return new MC_User(
            data[this.FIELD_UID] as string,
            data[this.FIELD_ENABLED] as boolean,
            data[this.FIELD_ADMIN] as boolean,
            data[this.FIELD_NAME] as string,
            data[this.FIELD_EMAIL] as string,
            data[this.FIELD_PHONE] as string,
            data[this.FIELD_ORG_IDS] as string[],
            created,
            modified,
            lastActivity,
            data[this.FIELD_ADMIN_NOTES] as string
        );
    }

    public static fromArrayData(dataArray: any[]): MC_User[] {
        let users: MC_User[] = [];
        for (let i = 0; i < dataArray.length; i++) {
            try {
                users[users.length] = this.fromData(dataArray[i]);
            } catch (e) {
                console.error("Err parsing user: " + e + ": " + JSON.stringify(dataArray[i]));
            }
        }
        return users;
    }

}

